var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.styles},[_vm._v(_vm._s(_vm.formatted))])}
var staticRenderFns = []

export { render, staticRenderFns }